var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"dt-checkbox"},[_c('label',{staticClass:"md-check"},[_c('input',{staticClass:"has-value",attrs:{"type":"checkbox","disabled":_vm.isCheckboxDisabled},domProps:{"value":_vm.key,"checked":_vm.isSelected(_vm.key)},on:{"click":function($event){return _vm.toggleSelected(_vm.key)}}}),_c('i',{staticClass:"indigo"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }